import React from 'react'

const LoadingScreen = props => {
  return (
    <div id='loading-screen'>
      <img alt='icon' src='/images/orange-wedge.png' className='loading-icon' />
      <br />
      loading...
    </div>
  )
}

export default LoadingScreen
